const DetailsGrid = ({ userDetails = {}, roleChangeRequestObj = {}, onDelete }) => {
    const items = [
        { label: "Регион пользователя", value: userDetails.region },
        { label: "Email пользователя", value: userDetails.email },
        { label: "Полное имя", value: `${userDetails.firstName || ""} ${userDetails.lastName || ""}`.trim() },
        {
            label: "Номер указанный в заявке",
            value: roleChangeRequestObj.contactNumber,
            href: roleChangeRequestObj.contactNumber ? `tel:${roleChangeRequestObj.contactNumber}` : undefined
        },
        { label: "Желаемая роль", value: roleChangeRequestObj.newRole },
        { label: "Описание проблемы", value: roleChangeRequestObj.description, full: true }
    ];

    return (
        <div className="dg">
            <div className="dg__toolbar">
                <button type="button" className="dg__danger" onClick={onDelete}>Удалить заявку</button>
            </div>
            <div className="dg__grid">
                {items.map((it, i) => (
                    <div key={i} className={`dg__item ${it.full ? "dg__item--full" : ""}`}>
                        <div className="dg__label">{it.label}</div>
                        {it.href ? (
                            <a className="dg__value" href={it.href}>{it.value || "—"}</a>
                        ) : (
                            <div className="dg__value">{it.value || "—"}</div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DetailsGrid;
